import utils from './utils'
import api from "./api";
import websocket from "./websocket";
import data from './data';

var app = {
  utils,
  api,
  websocket,
  data
};

export default app;
